/* eslint-disable @typescript-eslint/no-empty-function */
import {
  createContext,
  useMemo,
  useState,
  useContext,
  useReducer,
} from "react";
import { CustomersTableRow } from "../pages/customers/CustomersTable";
import { Company } from "../types/company";

type BitrixContextType = {
  deal: CustomersTableRow | null;
  dealList: CustomersTableRow[];
  setDealList: React.Dispatch<React.SetStateAction<CustomersTableRow[]>>;
  setDeal: React.Dispatch<React.SetStateAction<CustomersTableRow | null>>;
  company: Company | null;
  companyList: Company[];
  setCompanyList: React.Dispatch<React.SetStateAction<Company[]>>;
  setCompany: React.Dispatch<React.SetStateAction<Company | null>>;
  loadingTrigger: boolean;
  triggerLoading: React.DispatchWithoutAction;
};

export const BitrixContext = createContext<BitrixContextType | null>(null);

// ----------------------------------------------------------------------

type BitrixProviderProps = {
  children: React.ReactNode;
};

export function BitrixProvider({ children }: BitrixProviderProps) {
  const [dealList, setDealList] = useState<CustomersTableRow[]>([]);
  const [deal, setDeal] = useState<CustomersTableRow | null>(null);
  const [companyList, setCompanyList] = useState<Company[]>([]);
  const [company, setCompany] = useState<Company | null>(null);
  const [loadingTrigger, triggerLoading] = useReducer((state) => !state, false);

  const memoizedValue = useMemo(
    () => ({
      dealList,
      deal,
      setDealList,
      setDeal,
      company,
      companyList,
      setCompanyList,
      setCompany,
      loadingTrigger,
      triggerLoading,
    }),
    [
      dealList,
      deal,
      setDealList,
      setDeal,
      company,
      companyList,
      setCompanyList,
      setCompany,
      loadingTrigger,
      triggerLoading,
    ],
  );

  return (
    <BitrixContext.Provider value={memoizedValue}>
      {children}
    </BitrixContext.Provider>
  );
}

export const useBitrixContext = () => {
  const context = useContext(BitrixContext);

  if (!context)
    throw new Error(
      "useBitrixContext context must be use inside BitrixProvider",
    );

  return context;
};
